module.exports = __webpack_public_path__ + "img/success-result.6c3a9d63.png";